import { useState } from 'react'
import { Dropdown } from 'antd'
import cn from 'classnames'
import { MenuItems } from './MenuItems'
import { ReactComponent as ThreeDots } from 'assets/svg/Dots24.svg'
import { TMenu } from './types'

export const GpoMenu = ({ uuid }: TMenu) => {
  const [visible, setVisible] = useState(false)
  return (
    <Dropdown
      onVisibleChange={() => setVisible(!visible)}
      visible={visible}
      className="menu-items"
      overlay={<MenuItems setVisible={setVisible} uuid={uuid} />}
      placement="bottomRight"
      trigger={['click']}
    >
      <div className={cn('dots-items')} onClick={(e) => e.stopPropagation()}>
        <ThreeDots />
      </div>
    </Dropdown>
  )
}
